import { useQuery, useStatus } from "@powersync/react";
import { StartupScreen } from "@cliqsuite/ui";
import { planLocked, type PlanFields } from "@cliqsuite/db/powersync";
import { KitchenBoard } from "../components/KitchenBoard";
import { NotEnabledScreen, PairScreen, PlanEndedScreen, UnpairedScreen } from "../components/Gate";
import { useKdsSession } from "../lib/useKdsSession";

export function HomePage() {
  const session = useKdsSession();
  const { data } = useQuery<PlanFields & { installed_modules: string | null }>(
    "SELECT installed_modules, subscription_status, subscription_period_end, grace_period_ends_at FROM businesses WHERE id = ?",
    [session.device?.businessId ?? ""],
  );
  const business = data[0];
  const { hasSynced } = useStatus();

  if (!session.device) return <PairScreen error={session.pairError} pairing={session.pairing} onPair={session.pair} />;
  const storeName = session.device.storeName;
  if (session.remoteUnpaired) return <UnpairedScreen storeName={storeName} onPairAgain={session.unpair} />;
  // First boot after pairing: nothing has synced yet, so there is no board to show.
  if (!business && !hasSynced) return <StartupScreen app="KDS" hint={`${session.device.registerName}, ${storeName}`} label="Getting today's tickets" />;
  if (business && planLocked(business)) return <PlanEndedScreen storeName={storeName} />;
  if (business && !(JSON.parse(business.installed_modules ?? "[]") as string[]).includes("restaurant")) {
    return <NotEnabledScreen storeName={storeName} onUnpair={session.unpair} />;
  }
  return <KitchenBoard device={session.device} onUnpair={session.unpair} />;
}
